/**
 * Report template type values
 */
export enum ReportTemplateTypeEnum {
	TEMPLATE = 'template',
	PARTIAL = 'partial',
}
